<template>
  <v-layout :class="['character-counter', hasError && 'error-color']" row wrap>
    <v-flex>{{ currentLength }}/{{ maxLength }} characters</v-flex>
    <v-flex class="text-right" v-if="hasError && !!errorMessage">{{errorMessage}}</v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    currentLength: {
      type: Number,
      required: true,
    },
    maxLength: {
      type: Number,
      required: true,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_colors.scss";

.character-counter {
  background-color: $ypo-light-gray;
  color: $mild-grey;
  padding: 8px 12px;
  font-size: 14px;
  margin-top: -4px;
  text-align: left;
  border-left: 1px solid $mild-grey;
  border-right: 1px solid $mild-grey;
  border-bottom: 1px solid $mild-grey;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  @include breakpointMin(sm) {
    border-radius: 0;
  }
}
</style>
